import React from 'react';
import { LazyMotion } from 'framer-motion';
const loadFeatures = () => import('./motion-features.js').then(res => res.default);
export const MotionWrapper = ({ children }) => {
    return (React.createElement(LazyMotion, { strict: true, features: loadFeatures }, children));
};
//# sourceMappingURL=index.js.map